import React, { useEffect } from 'react';
import { useAuthStore } from '../../stores/useAuthStore';
import { resumeSignupFollowUp } from '../../lib/signupFollowUp';

// 가입 직후 뒤처리(추천인 연결·가입 환영 알림톡·약관 동의 기록·가입 접속 정보)가 새로고침 등으로 끊겼으면,
// 앱이 다시 켜져 로그인이 확인될 때 남은 단계만 마저 한다(2026-10-22, lib/signupFollowUp). 화면에는 아무것도 그리지 않는다.
export const SignupFollowUpResume: React.FC = () => {
    const user = useAuthStore((state) => state.user);
    const isInitialized = useAuthStore((state) => state.isInitialized);

    useEffect(() => {
        if (!isInitialized || !user) return;
        void resumeSignupFollowUp(user);
    }, [isInitialized, user]);

    return null;
};
